import {
  TableRow as MUITableRow,
  TableCell as MUITableCell,
  Radio,
} from "@mui/material";
import {
  TableColumn,
  TableRow as ITableRow,
  OnRowSelectCb,
} from "./Table.types";
import { TableCell } from "./TableCell";

export interface TableRowProps {
  row: ITableRow;
  readonly?: boolean;
  columns: TableColumn[];
  isSelected: boolean;
  onRowSelect: OnRowSelectCb;
  condensed: boolean;
}

export const TableRow = ({
  row,
  isSelected,
  onRowSelect,
  readonly,
  columns,
  condensed,
}: TableRowProps) => {
  return (
    <MUITableRow
      hover
      onClick={onRowSelect(row)}
      role="checkbox"
      aria-checked={isSelected}
      selected={isSelected && !readonly}
      tabIndex={-1}
      key={"table-row-" + row.id}
      style={{ cursor: "pointer" }}
    >
      <MUITableCell padding="checkbox">
        {!readonly && (
          <Radio
            color="primary"
            checked={isSelected}
            inputProps={{
              "aria-labelledby": `enhanced-table-checkbox-${row.id}`,
            }}
          />
        )}
      </MUITableCell>
      {columns.map((column) => (
        <TableCell
          column={column}
          row={row}
          key={column.id}
          condensed={condensed}
        />
      ))}
    </MUITableRow>
  );
};
